<template>
  <multiselect
    v-model="selected"
    @input="onChange"
    :options="options"
    :custom-label="labelSubEvento"
    :multiple="isMulti"
    :taggable="isTagabble"
    selectLabel=""
    selectedLabel="«"
    deselectLabel=""
    :allowEmpty="false"
    :preselectFirst="true"
    label="nome"
    track-by="id"
    :disabled="isDisabled"
    placeholder=""
    :loading="isLoading"
  >
    <template slot="noResult" slot-scope="props">
      <span>{{ $t('Nenhum elemento encontrado.') }}</span>
    </template>
    <template slot="noOptions" slot-scope="props">
      <span>{{ $t('Nenhum dado foi retornado.') }}</span>
    </template>
    <template slot="placeholder" slot-scope="props">
      <span>{{ emptyLabel }}</span>
    </template>
    <template slot="tag" slot-scope="{ option }"
      ><span class="badge badge-primary mr-1"
        ><span class="text-truncate mr-1 mb-1">{{ option.nome }}</span
        ><span class="custom__remove badge" @mousedown.prevent.stop="removeOption(option)">x</span></span
      ></template
    >
    <template slot="clear" slot-scope="props">
      <div class="multiselect__clear" @mousedown.prevent.stop="clearAll(props.search)"></div>
    </template>
  </multiselect>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="@/vendor/libs/vue-multiselect/vue-multiselect.scss" lang="scss"></style>

<script>
import Multiselect from 'vue-multiselect';
export default {
  components: {
    Multiselect
  },
  props: [
    'nameField',
    'esporteSelected',
    'isRequired',
    'isDisabled',
    'emptyLabel',
    'includeAll',
    'isMulti',
    'isTagabble',
    'alreadyAdded',
    'keepSelected',
    'checkActive',
    'exibirSubeventosModelo',
    'onlyWinner',
    //propriedade usada para perfis, lá precisa de todos os subeventos.
    'perfil',
    'forceSelected',
    'hideBuilder',
    'showAllEspeciais',
    'idsToShow',
    'ignoreEsporteSelected'
  ],

  data() {
    return {
      selected: [],
      value: [],
      options: [],
      isLoading: false
    };
  },

  methods: {
    onChange(e) {
      this.$emit('input', e);
      if (e == null) {
        this.$emit('selectChange', 'sub_evento', null);
        return;
      }
      this.$emit('selectChange', 'sub_evento', e);
    },
    setValue(value) {
      if (this.forceSelected) {
        this.selected = this.options.find((option) => option.id === this.forceSelected);
        this.$emit('input', this.selected);
        return;
      }
      if (this.isTagabble) {
        this.selected = value;
        this.removeOptions(value);
        this.$emit('input', value);
        this.$emit('selectChange', 'sub_evento', value);
      } else {
        if (value) {
          if (value.id) {
            this.selected = this.options.find((option) => option.id === value.id);
          } else {
            this.selected = this.options.find((option) => option.id === value);
          }
        } else {
          this.selected = this.options.find((option) => option.id === null);
        }

        this.$emit('input', this.selected);
      }
    },
    setOptions(esporteId) {
      if (this.exibirSubeventosModelo) {
        this.options = [];
        if (this.includeAll) {
          this.options = [{ id: null, nome: this.$i18n.t(this.emptyLabel) }];
        }
        this.options = this.options.concat(this.alreadyAdded);
        return;
      }
      this.selected = null;
      this.isLoading = true;

      let where = '1=1';

      if (esporteId) {
        where += ` and tipo_subevento.tipo_esporte=${esporteId}`;
      }

      if (this.checkActive == true) {
        where += ` and tipo_subevento.ativo = true `;
      }

      if (!this.perfil) {
        if (this.onlyWinner == true) {
          where += ` and tipo_subevento.id IN (917, 1053)`;
        } else {
          if (this.showAllEspeciais === true) {
          } else {
            where += ` and tipo_subevento.id NOT IN (917, 1053)`;
          }
        }
      }

      if (this.hideBuilder === true) {
        where += ` and tipo_subevento.id NOT IN (631)`;
      }

      this.$atenaList
        .getCommon('tipo_subevento', {
          columns: '*',
          filter: where,
          order: 'nome'
        })
        .then((res) => {
          if (this.idsToShow?.length) {
            res.data = res.data.filter((item) =>
              this.idsToShow.map((id) => parseInt(id)).includes(parseInt(item.id))
            );
          }

          this.isLoading = false;
          this.options = [];
          if (this.includeAll) {
            this.options = [{ id: null, nome: this.$i18n.t(this.emptyLabel) }];
          }
          this.options = this.options.concat(res.data);
          if (this.alreadyAdded) {
            if (this.nameField) {
              const nameFieldIndex = this.alreadyAdded.findIndex((event) => event.id === this.nameField);
              if (nameFieldIndex !== -1) {
                this.alreadyAdded.splice(nameFieldIndex, 1);
                this.setValue(this.nameField);
              }
            }
            this.removeOptions(this.alreadyAdded);
          }
          this.isLoading = false;
          if (this.forceSelected) {
            this.setValue(this.forceSelected);
            return;
          }
          if (!this.nameField?.id) {
            this.selected = this.options.find((option) => option.id === this.nameField);
          }
        })
        .catch((err) => {
          this.isLoading = false;
          this.$notify({
            group: 'notifications-default',
            type: 'error',
            title: this.$i18n.t('Erro ao Carregar Dados'),
            text: this.$i18n.t('Entre em contato com o Administrador do Sistema.')
          });
        });
    },
    labelSubEvento({ nome, traducao }) {
      let objTraducao = {};
      if (traducao) objTraducao = JSON.parse(traducao);
      return traducao && objTraducao[this.$i18n.locale] ? `${objTraducao[this.$i18n.locale]}` : `${nome}`;
    },
    removeOptions(options) {
      if (!options) return;
      let opt = [];
      this.options.forEach((element) => {
        const el = options.find((el) => el.id === element.id);
        if (!el) opt.push(element);
      });
      this.options = opt;
    },
    removeOption(option) {
      if (!option) return;
      let valueCp = [];
      this.selected.forEach((element) => {
        const el = this.selected.find((el) => el.id === option.id);
        if (el) {
          valueCp = this.selected.filter((elem) => elem.id != el.id);
        }
      });

      this.setValue(valueCp);
      this.options = [option, ...this.options];
    }
  },

  watch: {
    esporteSelected(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.setOptions(newVal);
      }
    },
    alreadyAdded(newVal, oldVal) {
      if (newVal !== oldVal && this.esporteSelected !== null) {
        this.setOptions(this.esporteSelected);
      }
    },
    nameField: function (value) {
      this.setValue(value);
    },
    onlyWinner() {
      if (this.esporteSelected) this.setOptions(this.esporteSelected);
    }
  },

  created() {
    if (this.esporteSelected) this.setOptions(this.esporteSelected);
    if (this.ignoreEsporteSelected) this.setOptions();
  }
};
</script>

<style lang="scss" scoped>
.custom__remove {
  background: #26b4ff !important;
  color: #fff;
  transition: ease 0.2s all;
}

.custom__remove:hover {
  cursor: pointer;
  background: #0097e9 !important;
}
</style>
